module.exports = __webpack_public_path__ + "img/explore_04.6b1b7591.jpg";